import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ElementContextCommonCode2fsa3eucy75um as ElementContextCommonCode } from './ElementContext.mjs';
import { DynamicCssr3610hzbsxx2 as DynamicCss } from './DynamicCss.js.mjs';
import { KiteUiCsshhimfofutzw8 as KiteUiCss } from './KiteUiCss.mjs';
import { Default_getInstancee1f46otjvolq as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var ElementContextClass;
function ElementContext() {
  if (ElementContextClass === VOID) {
    class $ extends ElementContextCommonCode() {
      constructor(basePath, dynamicCss, kiteUiCss, parent) {
        dynamicCss = dynamicCss === VOID ? new (DynamicCss())(basePath) : dynamicCss;
        kiteUiCss = kiteUiCss === VOID ? new (KiteUiCss())(dynamicCss) : kiteUiCss;
        parent = parent === VOID ? null : parent;
        super(parent);
        this.basePath_1 = basePath;
        this.dynamicCss_1 = dynamicCss;
        this.kiteUiCss_1 = kiteUiCss;
        this.id_1 = Default_getInstance().nextInt_ujorgc_k$();
        this.immersiveMode_1 = false;
      }
      split_1ta5ga_k$() {
        return new (ElementContext())(this.basePath_1, this.dynamicCss_1, this.kiteUiCss_1, this);
      }
      toString() {
        return 'RContext@' + this.id_1;
      }
    }
    initMetadataForClass($, 'ElementContext');
    ElementContextClass = $;
  }
  return ElementContextClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  ElementContext as ElementContext16kjlmo0pjcp3,
};
//endregion

//# sourceMappingURL=ElementContext.commonHtml.mjs.map
